import React from 'react';
import Navbar from './components/Navbar'; //ignore red underline
import Footer from './components/Footer';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import ScrollToTop from './components/pages/ScrollToTop';


//Home
import Home from './components/pages/Home';
import About from './components/pages/About';
import Ministries from './components/pages/Ministries';
import Sermons from './components/pages/Sermons';
import Calendar from './components/pages/Calendar';
import Giving from './components/pages/Giving';
import ContactUs from './components/pages/ContactUs';

//About
import Gospel from './components/pages/About/Gospel';
import Leadership from './components/pages/About/Leadership';
import History from './components/pages/About/History';
import SOF from './components/pages/About/SOF';

//Bios
import LarryLoden from './components/pages/Bios/LarryLoden';
import MicahMonfrini from './components/pages/Bios/MicahMonfrini';
import DaveWolfe from './components/pages/Bios/DaveWolfe';
import DarrellHayslip from './components/pages/Bios/DarrellHayslip';
import WillSanderson from './components/pages/Bios/WillSanderson';
import DanVoss from './components/pages/Bios/DanVoss';


//Ministries
import Outreach from './components/pages/Ministries/Outreach';
import Men from './components/pages/Ministries/Men';
import Women from './components/pages/Ministries/Women';
import YouthGroup from './components/pages/Ministries/YouthGroup';
import ChildrensMinistry from './components/pages/Ministries/ChildrensMinistry';
import Nursery from './components/pages/Ministries/Nursery';



function App() {
  return (

    <BrowserRouter>
    <Navbar />
    <ScrollToTop/>
    <Footer/>
    <Routes>
      {/* use ELEMENT in place of COMPONENT or else it will not render!! */}
      <Route path='/' element={<Home/>}/>
      <Route path='/about' element={<About/>}/>
      <Route path='/ministries' element={<Ministries/>}/>
      <Route path='/sermons' element={<Sermons/>}/>
      <Route path='/calendar' element={<Calendar/>}/>
      <Route path='/giving' element={<Giving/>}/>
      <Route path='/contact-us' element={<ContactUs/>}/>

      <Route path='/about/gospel' element={<Gospel/>}/>
      <Route path='/about/leadership' element={<Leadership/>}/>
      <Route path='/about/history' element={<History/>}/>
      <Route path='/about/statement-of-faith' element={<SOF/>}/>

      <Route path='/about/leadership/larry-loden' element={<LarryLoden/>}/>
      <Route path='/about/leadership/micah-monfrini' element={<MicahMonfrini/>}/>
      <Route path='/about/leadership/dave-wolfe' element={<DaveWolfe/>}/>
      <Route path='/about/leadership/darrell-hayslip' element={<DarrellHayslip/>}/>
      <Route path='/about/leadership/will-sanderson' element={<WillSanderson/>}/>
      <Route path='/about/leadership/dan-voss' element={<DanVoss/>}/>

      <Route path='/ministries/outreach' element={<Outreach/>}/>
      <Route path='/ministries/men' element={<Men/>}/>
      <Route path='/ministries/women' element={<Women/>}/>
      <Route path='/ministries/youth-group' element={<YouthGroup/>}/>
      <Route path='/ministries/childrens-ministry' element={<ChildrensMinistry/>}/>
      <Route path='/ministries/nursery' element={<Nursery/>}/>
    </Routes>
  
    </BrowserRouter>

  );
}

export default App;
